import { Divider } from '../../../Divider'
import { Skeleton } from '../../../Skeleton'
import { ENTITY_PROFILE_TAB_UPDATES_SKELETON_INDICES } from '../EntityProfileTabUpdates.constants'

import * as styles from './EntityProfileTabUpdatesCardSkeleton.module.css'

function EntityProfileTabUpdatesCardSkeleton() {
  return (
    <div className={styles.group}>
      <div className={styles.heading}>
        <Divider className={styles.divider} />
        <Skeleton className={styles.title} />
        <Divider className={styles.divider} />
      </div>
      <div className={styles.items}>
        {ENTITY_PROFILE_TAB_UPDATES_SKELETON_INDICES.map(index => (
          <div className={styles.card} key={index}>
            <Skeleton className={styles.avatar} />
            <div className={styles.content}>
              <Skeleton className={styles.cardTitle} />
              <Skeleton className={styles.text} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default EntityProfileTabUpdatesCardSkeleton
